import { render, staticRenderFns } from "./ReturnDetailsModal.vue?vue&type=template&id=b6eb0724"
import script from "./ReturnDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReturnDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports